import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-onboarding-status-badge',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './onboarding-status-badge.component.html',
  styleUrl: './onboarding-status-badge.component.scss',
})
export class OnboardingStatusBadgeComponent {
  status = input.required<string>();
}
